import { eDuTruHocBongActionsObj } from "../../action-types/bao-cao/IDuTruHocBongActions";
import { generateActions } from "../generateActions";

export const duTruHocBongActions = {
  ...generateActions(eDuTruHocBongActionsObj, "DU_TRU_HOC_BONG"),
};
